import objectAssign from 'object-assign';

const initialState = {
	drama: [],
	situation: [],
}

const getCd = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_CD_SUCCESS': {
			return objectAssign(
				{},
				state,
				action.data,
			);
		}
		default: {
			return state;
		}
	}
}

export default getCd



// WEBPACK FOOTER //
// src/reducers/getCd.js